"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Barging = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Barging_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.337 1a4.6 4.6 0 0 0 4.107 4.374v-.193c0-1.422 1.666-2.191 2.748-1.269l3.306 2.82c.78.665.78 1.87 0 2.536l-3.306 2.82c-1.082.922-2.748.153-2.748-1.269v-.193A4.6 4.6 0 0 0 2.337 15h8.996a2.333 2.333 0 0 0 2.333-2.333V3.333A2.333 2.333 0 0 0 11.333 1H2.337Zm-.204-1a.8.8 0 0 0-.8.8 5.6 5.6 0 0 0 5.6 5.6h.3a.21.21 0 0 0 .211-.21V5.18a.667.667 0 0 1 1.1-.507l3.305 2.82a.667.667 0 0 1 0 1.014l-3.306 2.82a.667.667 0 0 1-1.099-.508V9.811a.21.21 0 0 0-.21-.211h-.301a5.6 5.6 0 0 0-5.6 5.6.8.8 0 0 0 .8.8h9.2a3.333 3.333 0 0 0 3.333-3.333V3.333A3.333 3.333 0 0 0 11.333 0h-9.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Barging_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Barging;
exports["default"] = _default;